import { useEffect, useState } from 'react';
import { getEasternDateKey } from '../utils/timeOffUsage';

/**
 * Keeps long-lived dashboard tabs aligned with the backend's Eastern calendar
 * across midnight and Jan 1 without requiring a manual reload.
 */
export const useEasternToday = () => {
  const [todayYmd, setTodayYmd] = useState(() => getEasternDateKey());

  useEffect(() => {
    const refreshDate = () => {
      const next = getEasternDateKey();
      setTodayYmd((current) => current === next ? current : next);
    };
    const intervalId = window.setInterval(refreshDate, 60_000);
    window.addEventListener('focus', refreshDate);
    document.addEventListener('visibilitychange', refreshDate);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', refreshDate);
      document.removeEventListener('visibilitychange', refreshDate);
    };
  }, []);

  return todayYmd;
};

